export { default } from './DialogContentText';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/DialogContentText/index.js
// module id = 167
// module chunks = 0